// Parse the Afirme terminal (TPV) per-sale report — "Comprobante_de_transaccion.csv".
// This bridges the bank statement and our recorded card payments: each card sale
// appears on the Afirme bank statement as a "VENTA TPVDB/TPVCR" deposit on its
// Fecha Depósito (a few days after Fecha Venta), while our sellers record the
// payment in `transactions` (account "Terminal Afirme") dated ~Fecha Venta. So we
// match: bank VENTA line ←(Importe + Fecha Depósito)→ TPV row ←(Importe + Fecha
// Venta + card type)→ our transaction → reservation / client.
//
// Columns: Comercio, Número de Tarjeta, Fecha Venta, Hora, Terminal, Transacción,
//          Autorización, Indentificación (brand), Tipo (Crédito/Débito), Importe,
//          Fecha Depósito.  Dates are dd/mm/yyyy.

const toISO = (ddmmyyyy) => {
  const m = String(ddmmyyyy).match(/(\d{2})\/(\d{2})\/(\d{4})/);
  return m ? `${m[3]}-${m[2]}-${m[1]}` : null;
};

const splitCsvLine = (line) =>
  // Simple split is safe here (no quoted commas in this export), but tolerate them.
  line.match(/("([^"]|"")*"|[^,]*)(,|$)/g)?.slice(0, -1).map((c) =>
    c.replace(/,$/, "").replace(/^"|"$/g, "").replace(/""/g, '"').trim()
  ) || line.split(",");

export function isAfirmeTpv(text) {
  const first = String(text).replace(/^﻿/, "").split(/\r?\n/)[0] || "";
  return /Comercio/i.test(first) && /Fecha\s*Dep[oó]sito/i.test(first);
}

export function parseAfirmeTpv(text) {
  const lines = String(text).replace(/^﻿/, "").split(/\r?\n/).filter((l) => l.trim());
  if (lines.length < 2) return { sales: [] };
  const sales = [];
  for (let i = 1; i < lines.length; i++) {
    const f = splitCsvLine(lines[i]);
    if (f.length < 11) continue;
    const amount = parseFloat(String(f[9]).replace(/[,$\s]/g, ""));
    const saleDate = toISO(f[2]);
    const depositDate = toISO(f[10]);
    if (!Number.isFinite(amount) || !saleDate) continue;
    const tipo = (f[8] || "").toLowerCase();
    const cardLast4 = (String(f[1]).match(/(\d{4})\s*$/) || [])[1] || "";
    sales.push({
      comercio: (f[0] || "").trim(),
      cardLast4,
      saleDate,
      time: (f[3] || "").trim(),
      terminal: (f[4] || "").trim(),
      transaccion: (f[5] || "").trim(),
      auth: (f[6] || "").trim(),
      brand: (f[7] || "").trim(),               // Visa | Mastercard
      cardType: tipo.startsWith("cr") ? "credit" : tipo.startsWith("db") || tipo.startsWith("dé") || tipo.startsWith("de") ? "debit" : "",
      amount: Math.abs(amount),
      depositDate: depositDate || saleDate,
    });
  }
  return { sales };
}
